import * as Actions from '../../actions';

const initialState = { data: null };

const listSplitProducerReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_SPLIT_PRODUCER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listSplitProducerReducer;
